<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: 'welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>属性管理</el-breadcrumb-item>
      <el-breadcrumb-item>报名人群类型</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
      <!-- 搜索和添加 -->
      <div class="search-wrapper">
        <div class="search-toggle" @click="toggleSearch" v-show="isMobile">
        <i :class="isSearchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        <span>{{ isSearchExpanded ? '收起筛选' : '展开筛选' }}</span>
      </div>
      <div class="search-content" v-show="!isMobile || isSearchExpanded" :class="{ 'search-content-mobile': isMobile }">
          <el-row :gutter="20">
            <el-col :span="7">
              <el-input
                placeholder="请输入中文名称"
                v-model="searchQuery.name_cn"
                clearable
                @clear="fetchAudiences"
                size="medium"
              >
                <el-button slot="append" icon="el-icon-search" @click="fetchAudiences"></el-button>
              </el-input>
            </el-col>
            <el-col :span="7">
              <el-input
                placeholder="请输入维语名称"
                v-model="searchQuery.name_ug"
                clearable
                @clear="fetchAudiences"
                size="medium"
              >
                <el-button slot="append" icon="el-icon-search" @click="fetchAudiences"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="showAddDialog = true" size="medium">添加人群类型</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 人群类型列表 -->
      <div class="table-scroll-wrapper">
        <el-table :data="audienceList" style="width: 100%; margin-top: 20px" border stripe>
        <el-table-column label="#" type="index" width="60" align="center"></el-table-column>
        <el-table-column label="中文名称" prop="name_cn" align="center"></el-table-column>
        <el-table-column label="维语名称" prop="name_ug" align="center"></el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                @click="editAudience(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="deleteAudience(scope.row.audience_id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      </div>

      
    </el-card>

    <!-- 添加人群类型对话框 -->
    <el-dialog title="添加人群类型" :visible.sync="showAddDialog" width="350px" @close="resetForm('addForm')">
      <el-form :model="audienceForm" :rules="audienceFormRules" ref="addForm" label-width="100px">
        <el-form-item label="中文名称" prop="name_cn">
          <el-input v-model="audienceForm.name_cn"></el-input>
        </el-form-item>
        <el-form-item label="维语名称" prop="name_ug">
          <el-input v-model="audienceForm.name_ug"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddDialog = false">取 消</el-button>
        <el-button type="primary" @click="addAudience">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑人群类型对话框 -->
    <el-dialog title="编辑人群类型" :visible.sync="showEditDialog" width="350px" @close="resetForm('editForm')">
      <el-form :model="audienceForm" :rules="audienceFormRules" ref="editForm" label-width="100px">
        <el-form-item label="中文名称" prop="name_cn">
          <el-input v-model="audienceForm.name_cn"></el-input>
        </el-form-item>
        <el-form-item label="维语名称" prop="name_ug">
          <el-input v-model="audienceForm.name_ug"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="updateAudience">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Audiences',
  data() {
    return {
      isSearchExpanded: false,
      isMobile: false,
      // 人群类型列表数据
      audienceList: [],
      // 搜索参数
      searchQuery: {
        name_cn: '',
        name_ug: ''
      },
      
      // 对话框显示控制
      showAddDialog: false,
      showEditDialog: false,
      // 表单数据
      audienceForm: {
        name_cn: '',
        name_ug: ''
      },
      // 表单验证规则
      audienceFormRules: {
        name_cn: [
          { required: true, message: '请输入人群类型中文名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        name_ug: [
          { required: true, message: '请输入人群类型维语名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchAudiences()
    this.checkIsMobile()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    fetchAudiences() {
      const params = {
        ...this.searchQuery
      }
      this.$http({ method: 'get', url: 'audiences', params })
        .then(res => {
          if (!res.success) return this.$message.error(res.message)
          this.audienceList = res.data
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '获取人群类型列表失败')
        })
    },
    addAudience() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return
        this.$http({ method: 'post', url: 'audiences', data: this.audienceForm })
          .then(res => {
            if (!res.success) return this.$message.error(res.message)
            this.$message.success('添加人群类型成功')
            this.showAddDialog = false
            this.fetchAudiences()
          })
          .catch(err => {
            this.$message.error(err.response?.data?.message || '添加人群类型失败')
          })
      })
    },
    editAudience(row) {
      this.audienceForm = { ...row }
      this.showEditDialog = true
    },
    updateAudience() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        this.$http({ method: 'put', url: `audiences/${this.audienceForm.audience_id}`, data: this.audienceForm })
          .then(res => {
            if (!res.success) return this.$message.error(res.message)
            this.$message.success('更新人群类型成功')
            this.showEditDialog = false
            this.fetchAudiences()
          })
          .catch(err => {
            this.$message.error(err.response?.data?.message || '更新人群类型失败')
          })
      })
    },
    deleteAudience(id) {
      this.$confirm('此操作将永久删除该人群类型, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http({ method: 'delete', url: `audiences/${id}` })
            .then(res => {
              if (!res.success) return this.$message.error(res.message)
              this.$message.success('删除人群类型成功')
              this.fetchAudiences()
            })
            .catch(err => {
              this.$message.error(err.response?.data?.message || '删除人群类型失败')
            })
        })
        .catch(() => {})
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.audienceForm = {
        name_cn: '',
        name_ug: ''
      }
    },
    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded
    },
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    handleResize() {
      this.checkIsMobile()
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-top: 15px;
}

.el-input :deep(.el-input__inner) {
  font-family: inherit;
}

.search-wrapper {
  margin-bottom: 10px;
}

.search-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s;
}

.search-toggle:hover {
  color: #409eff;
}

.search-toggle i {
  font-size: 14px;
}

.search-content {
  padding-top: 10px;
}

.search-content-mobile {
  padding-top: 10px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-wrapper .el-table {
  min-width: 100%;
}



@media (max-width: 768px) {
  .el-card {
    margin-top: 10px;
    padding: 10px;
  }

  .el-table {
    font-size: 11px;
    overflow-x: auto;
    display: block;
  }

  .el-table th,
  .el-table td {
    padding: 8px 5px !important;
  }

  .el-table .el-button--mini {
    padding: 3px 6px;
    font-size: 10px;
  }

  .search-content .el-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-content .el-row .el-col {
    width: 100% !important;
    margin-bottom: 5px;
  }

  .search-toggle {
    padding: 10px 0;
    font-size: 13px;
  }

  .el-dialog {
    width: 90% !important;
    margin: 0 auto;
  }
}
</style>